<template>
  <HeaderTrade />

     <!-- Container Start { -->
     <div id="container">
       <!-- Contents Start { -->
       <div id="contents">

         <TradeTopNav />

         <!-- content start -->
         <div class="contents-area">

            <!--  start -->
            <div class="trade-result-box fm-top-tab">
              <div class="fm-tab-list">
                <!-- tab button -->
                <ul class="nav nav-tabs">
                  <li class="nav-item"><button type="button" @click="onResultTab('S')" class="nav-link" :class="resultType == 'S' ? 'active' : ''">주식거래</button></li>
                  <li class="nav-item"><button type="button" @click="onResultTab('F')" class="nav-link" :class="resultType == 'F' ? 'active' : ''">선물거래</button></li>
                  <li class="nav-item"><button type="button" @click="onResultTab('C')" class="nav-link" :class="resultType == 'C' ? 'active' : ''">코인거래</button></li>
                  <li class="nav-item"><button type="button" @click="onResultTab('G')" class="nav-link" :class="resultType == 'G' ? 'active' : ''">코인선물</button></li>
                </ul>
              </div>
            </div>
            
            <div v-if="!isApplyCurrentSpace"> 
              <p class="p-5 text-center text-secondary">참가한 대회가 아닙니다.</p>
            </div>
            <div class="result-box-contents" v-else>
              <div class="result-box-top">
                <div class="top-inner" :class="Constant.UTIL.getUpdownColor(profitPer)">
                  <span class="txt">총 보유자산<span>({{resultType=='G'?'USDT':'원'}})</span></span>
                  <span class="num">  {{resultType=='G'?Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(totalBalance, 2)):Constant.UTIL.numberWithCommas(Math.floor(totalBalance))}}</span>
                </div>
                <div class="top-inner" :class="Constant.UTIL.getUpdownColor(profitPer)">
                  <span class="txt">수익률</span>
                  <span class="num">{{Constant.UTIL.numberWithCommas(  Constant.UTIL.toFixedNum(profitPer,2))}}%</span>
                </div>
              </div>

              <!-- 투자내역 구분 >>> 주식/선물/코인거래 start -->
              <div v-if="resultType != 'G'">
                <div class="result-list-inner" 
                    v-for="AssetItem  in currentAssetList"
                    :key = AssetItem.ID 
                >

                  <div class="inner-head"   @click="onItemClicked(AssetItem)">
                    <div class="left">
                      <p class="txt">{{AssetItem.NAME}}</p>
                    </div>
                    <div class="right" :class="AssetItem.COLOR_CLASS">
                      <div>
                        <span class="txt">평가손익</span>
                        <span class="num">{{AssetItem.PROFIT?AssetItem.PROFIT:0}}</span>
                      </div>
                      
                      <!-- 주식, 코인 일때 포함 -->
                      <div v-if="resultType !== 'F'">
                        <span class="txt">수익률</span>
                        <span class="num">
                          <i></i>{{AssetItem.profitPre?Number(AssetItem.profitPre).toFixed(2) + '%':0}}
                        </span>
                      </div>

                    </div>
                  </div>

                  <div class="inner-body">
                    <ul class="body-list">
                      <li>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.COUNT, 4))}}</span>
                          <span class="txt">보유수량</span>
                        </div>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Number(AssetItem.PRICE))}}</span>
                          <span class="txt">매입가</span>
                        </div>
                      </li>
                      <li>
                        <div class="list-txt" v-if="resultType !== 'F'">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.COUNT * AssetItem.PRICE, 2))}}</span>
                          <span class="txt">매입금액</span>
                        </div>                      
                        <!-- 선물 일때 -->
                        <div class="list-txt" v-if="resultType == 'F'">
                          <span class="num">{{getTradeType(AssetItem.TRADETYPE)}}</span>
                          <span class="txt">구분</span>
                        </div>
                        <div class="list-txt"
                        :class="Constant.UTIL.getUpdownColor(AssetItem.drate)"
                        >
                          <span class="num" >{{AssetItem.currentPrice?Constant.UTIL.numberWithCommas(AssetItem.currentPrice):0}}</span>
                          <span class="txt">현재가</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


              <div v-else>
                <!-- //투자내역 구분 >>> 주식/선물/코인거래 End -->
                <!-- 투자내역 구분 >>> 코인선물 start -->
                <div class="result-list-inner"
                    v-for="AssetItem  in currentAssetList"
                    :key = AssetItem.ID 
                >
                  <div class="inner-head cf" @click="onItemClicked(AssetItem)">
                    <div class="left" :class="getLongShortColor(AssetItem.TRADETYPE)">
                      <p class="txt t2">{{AssetItem.NAME}}</p>
                      <span class="unit">Isolated {{ AssetItem.LEVERAGE?parseInt(AssetItem.LEVERAGE):'1'}}x</span>
                    </div>
                    <div class="right" :class="getCssColor(AssetItem._unrealizedPL)">
                      <div>
                        <span class="txt">평가손익</span>
                        <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem._unrealizedPL, 2))}}</span>
                      </div>
                      <div>
                        <span class="txt">수익률</span>
                        <span class="num">
                          <i></i>{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem._unrealizedPLPer, 2))+ '%'}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="inner-body">
                    <ul class="body-list">
                      <li>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Number(AssetItem.COUNT))}}</span>
                          <span class="txt">수량</span>
                        </div>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.PRICE, getNdotpos_G(AssetItem.CODE)))}}</span>
                          <span class="txt">진입가(USDT)</span>
                        </div>
                      </li>
                      <li>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(Number(AssetItem.PRICE)*Number(AssetItem.COUNT), 4))}}</span>
                          <span class="txt">주문금액(USDT)</span>
                        </div>
                        <div class="list-txt">
                          <span class="num" >{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.LQPRICE, getNdotpos_G(AssetItem.CODE)))}}</span>
                          <span class="txt">강제청산가격(USDT)</span>
                        </div>
                      </li>
                      <li>
                        <div class="list-txt">
                          <span class="num">{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.ASSET_MARGIN, 2))}}</span>
                          <span class="txt">포지션증거금(USDT)</span>
                        </div>
                        <div class="list-txt" :class="getCssColor(Number(AssetItem.TPOL))">
                          <span class="num" >{{Constant.UTIL.numberWithCommas(Constant.UTIL.toFixedNum(AssetItem.TPOL, 2))}}</span>
                          <span class="txt">실현손익(USDT)</span>
                        </div>
                      </li>
                    </ul>
                  </div>
              </div>  
                <!-- //투자내역 구분 >>> 코인선물 End -->

            </div>


            <div v-if="currentAssetList.length == 0"> 
              <p class="p-5 text-center text-secondary">보유종목이 없습니다.</p>
            </div>
          </div>
   
           <!-- // end -->
      
         </div>
         <!-- // content end -->

       </div>
       <!-- } Contents End -->
     </div>
     <!-- } Container End -->

</template>

<script>
import { useStore } from 'vuex';
import { onMounted, ref, watch, computed, onUnmounted } from 'vue'
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import {useApicall} from '@/composables/commonFn';
import Constant from '@/constant.js';
import { useScoket } from '@/socket';
//import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import {useGetItemList} from '@/composables/vtradeFn';
import axios from '@/axios';
import {useRouter}from 'vue-router'
export default {
   components:{   
       HeaderTrade,
       TradeTopNav,
      //  PerfectScrollbar
   },
   
   setup(){
    const store = useStore();
    const router = useRouter();
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0');
    store.commit('common/CHANGE_CURRENT_PAGE', 'TradeResultAll');
    const resultType = ref(null);
    const { apiCall_gt} = useApicall();
    const allTrade = computed(()=> store.state.hts.allTrade);
    const currencyInfo = computed(()=> store.state.hts.currencyInfo);
    const applySpace_S = ref(null);
    const applySpace_F = ref(null);
    const applySpace_C = ref(null);
    const applySpace_G = ref(null);
    const  {getItemListBySessionStorage} = useGetItemList();
   
    var currentBalance = null;
    var profitData = null;
    const profitPer  = ref(0);
    const totalBalance  = ref(0);  

    const currentAssetList = ref([]); 
    const {socket} = useScoket();

    const isApplyCurrentSpace = ref(false)

    var intervalId; 

    const getAssetList = async (type) => { 
          var spaceId=null
          if(type == 'S')
          {
            if(applySpace_S.value)
            {
                spaceId = applySpace_S.value.ID
            }
          }
          else if(type == 'F')
          {
            if(applySpace_F.value)
            {
                spaceId = applySpace_F.value.ID
            }
          }
          else if(type == 'C')
          {
            if(applySpace_C.value)
            {
                spaceId = applySpace_C.value.ID
            }
          }
          else if(type == 'G')
          {
            if(applySpace_G.value)
            {
                spaceId = applySpace_G.value.ID
            }
          }
          var result = []; 
          if(spaceId)
          {
            var res = await apiCall_gt(`vspace/getassetlist?spaceId=${spaceId}`); 
          //  console.log(res)
            result = res.dataList;
            if(result == null)result = [];
          }  
          return  result;   
      } 

    const getTradeType = (type) =>{
        switch(type)
        {
            case '1':
                return "매수"                        
            case '2':
                return "매도"                       
            case '3':
                return "매수"                        
            case '4':
                return "매도"
        }
    }


    const setApplySpaceList = async()=>{
      var res = await apiCall_gt(`vspace/getmyspacelist?applyType=A`);       
      var s = res.dataList.filter(Symbol => Symbol.STATUS == '1' && Symbol.TYPE == 'S');
      var f = res.dataList.filter(Symbol => Symbol.STATUS == '1' && Symbol.TYPE == 'F');
      var c = res.dataList.filter(Symbol => Symbol.STATUS == '1' && Symbol.TYPE == 'C');
      var g = res.dataList.filter(Symbol => Symbol.STATUS == '1' && Symbol.TYPE == 'G');
  
      if(s.length > 0)applySpace_S.value = s[0];
      if(f.length > 0)applySpace_F.value = f[0];
      if(c.length > 0)applySpace_C.value = c[0];
      if(g.length > 0)applySpace_G.value = g[0];


      onResultTab('S')


    // currentAssetList.value = await getAssetList('S');



     // if(applySpace_S.value)currentBalance = await getCurrentBalance(applySpace_S.value.ID);
     // if(applySpace_S.value)profitData = await getProfitlist('S',applySpace_S.value.ID);
     // if( currentAssetList.value.length > 0)
     // {
     // requesAssetItems(currentAssetList.value)
     // }

     //console.log("getApplySpaceList:", assetList_S.value, assetList_F.value, assetList_C.value, assetList_G.value)
    }

    watch(allTrade, async()=>{              
        var  tradeItem = allTrade.value;   
        if(tradeItem.itemType != 'G')return;
        //var assetList_g = await getItemListBySessionStorage('G');
       
        const found_long =  currentAssetList.value.find(element => element.CODE ==  tradeItem.code  && element.TRADETYPE == '3'); 
        const found_short = currentAssetList.value.find(element => element.CODE ==  tradeItem.code  && element.TRADETYPE == '4'); 
        // console.log('assetList_g: ',tradeItem)
        var unrealizedPL; 
        var unrealizedPLPer; 
        var realizedPL; 
        var feeVal;

        if(found_long)
        {
              feeVal = Number(found_long.PRICE) *  Number(found_long.COUNT) * (Number(found_long.FEES)/100);
              unrealizedPL = (Number(tradeItem.price) - Number(found_long.PRICE)) * Number(found_long.COUNT);  
              unrealizedPLPer = unrealizedPL / (Number(found_long.ASSET_MARGIN) + feeVal) * 100;
              // realizedPL =   unrealizedPL - feeVal; 
              realizedPL =   -feeVal; 
              // console.log("unrealizedPL:", unrealizedPL, feeVal)
              found_long._unrealizedPLPer = unrealizedPLPer;
              found_long._unrealizedPL = unrealizedPL;
              found_long._realizedPL = realizedPL;

              found_long.COLOR_CLASS = getCssColor(realizedPL);       

        }

        if(found_short)
        {
              feeVal = Number(found_short.PRICE) *  Number(found_short.COUNT) * (Number(found_short.FEES)/100);
              unrealizedPL = (Number(found_short.PRICE) - Number(tradeItem.price)) * Number(found_short.COUNT);  
              unrealizedPLPer = unrealizedPL / (Number(found_short.ASSET_MARGIN) + feeVal) * 100;
              //realizedPL =   unrealizedPL - feeVal;       
              realizedPL =  -feeVal; 
              found_short._unrealizedPLPer = unrealizedPLPer;
              found_short._unrealizedPL = unrealizedPL;
              found_short._realizedPL = realizedPL;

              found_short.COLOR_CLASS = getCssColor(realizedPL);              
        }
    })


    
    watch(allTrade, async()=>{          
      var  tradeItem = allTrade.value;   
      if(tradeItem.itemType == 'G')return;
      var  found =  null;        
      
      
      found = currentAssetList.value.find(element => element.CODE ==  tradeItem.code);  
      // if(!found) found = assetListData_F.value.find(element => element.CODE ==  tradeItem.code);           
      // if(!found) found = assetListData_C.value.find(element => element.CODE ==  tradeItem.code);           
      // if(!found) found = assetListData_G.value.find(element => element.CODE ==  tradeItem.code);           
      if(!found)return;        
      var profit; 
      
      if(tradeItem.itemType == 'F')
      { 
       
            var items =  await getItemListBySessionStorage('F')
            if(items)
            {
                var t_item =  items.find(element => element.CODE ==  found.CODE); 
            }
            //console.log("aaaa", items, t_item)
            if(t_item)
            {
                if(t_item.MINCHANGEAMOUNT)
                {

                    
                    if(t_item.PRODUCTCODE == 'HSI')
                    {
                        profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.HKD_KRW) * Number(found.COUNT);
                        found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.HKD_KRW);                        
                    }
                    else
                    {
                         
                        profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.USD_KRW) * Number(found.COUNT);
                        found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)) / Number(t_item.HOGAUNITPRICE) * Number(t_item.MINCHANGEAMOUNT) * Number(currencyInfo.value.USD_KRW);  
                                              
                    }
                }
                else
                {
                    if(t_item.SUBTYPE == 'K')
                    { 
                        profit = ((Number(tradeItem.trade_price) - Number(found.PRICE)) *Number(found.COUNT))*250000; 
                        found.nProfit = ((Number(tradeItem.trade_price) - Number(found.PRICE)))*250000;  
                    }
                } 
                found.currentPrice = tradeItem.trade_price;
                found.drate = Number(tradeItem.drate);
                //console.log("currencyInfo.value: ",found)
                
            } 
            if(found.TRADETYPE == '4')
            {
                found.nProfit *= -1;
                profit *= -1;
            }                 
            profit = Math.floor(profit)   

          
        }
        else
        {
          profit = (Number(tradeItem.trade_price) - Number(found.PRICE)) *Number(found.COUNT);  
          found.nProfit = (Number(tradeItem.trade_price) - Number(found.PRICE)); 
          let profitPre = (found.nProfit /  Number(found.PRICE)) *100;
          found.profitPre = profitPre;
          found.currentPrice = tradeItem.trade_price;
          if(tradeItem.itemType == 'C')
          {
              
              found.drate = Number(tradeItem.trade_price) -  Number(tradeItem.prev_closing_price);
          }
          else
          {
            found.drate = Number(tradeItem.drate);
          }          
          profit = Math.floor(profit);  
        }

        

        if(profit > 0)
        {
            found.COLOR_CLASS = "up"
            found.PROFIT = '+' + Constant.UTIL.numberWithCommas(profit);
            
        }
        else if(profit < 0)
        {
          found.COLOR_CLASS = "down"
          found.PROFIT =  Constant.UTIL.numberWithCommas(profit);
        }
        else
        {
          found.COLOR_CLASS = ""
          found.PROFIT = '0'
        } 

    })

    const leaveAssetItems =  (listData) => {   
        for(let i=0; i<listData.length; i++)
        {
          
            var item = listData[i];      
           // console.log("leaveAssetItems~000", item.CODE ) 
            socket.emit("leaveTrade", {
                itemType: item.type,
                code: item.CODE,                   
            }, function() {   
                 // console.log("leaveAssetItems~111", e )                      
            })
        }
    }

    const requesAssetItems =  (listData) => {   
        //console.log("requesAssetItems:", listData)
        if(listData && listData.length > 0)
        {
          var assetInitArr = []
          setTimeout(()=>{
              for(let i=0; i<listData.length; i++)
              {
                  var item = listData[i];         
                        
                  var assetInitData = 
                  { "drate" :  "0" , 
                    "trade_price" : Number(item.CURRENT),
                    "code": item.CODE,
                    "price": Number(item.CURRENT)
                  }

                  if(item.KIND == "S" || item.KIND == "C" || item.KIND == "G" )
                  {
                    item.type = item.KIND;
                    assetInitData.itemType = item.KIND;
                  }
                  else
                  {
                    item.type = 'F';
                    assetInitData.itemType = 'F';                           
                  }
                 // console.log("requestTrade~000", item.CODE ) 
                  assetInitArr.push(assetInitData);     
                  socket.emit("requestTrade", {
                      itemType:item.type,
                      code: item.CODE,
                      // isNight:isNight  
                  }, function() {       
                      // console.log("requestTrade~111", e ) 
                  })
              }

              for(let ii=0; ii<assetInitArr.length; ii++)
              {
                  //  console.log("aaaaaa~", assetInitArr.shift() ) 
                  setTimeout(()=>{
                      store.commit('hts/CHANGE_ALL_TEADE', assetInitArr.shift()) 
                  }, ii * 200)                    
              }
          },0)
        }
    }

    const setTotalProfit = (assetData)=>{    
        var totalProfit = 0; 
        if(resultType.value == 'G')
        {
                       
          for(let i=0; i<assetData.length ; i++)
          {
              let data = assetData[i]
              if(data)
              {
                  totalProfit += Number(data._unrealizedPL);                         
              }  
          } 
          if(isNaN(totalProfit)) return;
          if(currentBalance && profitData)
          {
              totalBalance.value = totalProfit +  Number(currentBalance.BALANCE); 
              let profit = Number(profitData.TPOL)+totalProfit
              profitPer.value = (profit/Number(currentBalance.PAYMONEY))*100;    
          }
        }
        else
        {         
          var totalPrice = 0;
          for(let i=0; i<assetData.length ; i++)
          {
              let data = assetData[i]
              if(data)
              {
                  totalProfit += Number(data.nProfit) *Number(data.COUNT);
                  totalPrice += (Number(data.PRICE) + Number(data.nProfit))  *Number(data.COUNT);                           
              }  
          }
          //console.log("currentBalance_S:", currentBalance_S)
          if(isNaN(totalProfit) || isNaN(totalPrice)) return
          if( currentBalance && profitData)
          {                
            totalBalance.value = totalPrice +  Number(currentBalance.BALANCE);    
            let profit = Number(profitData.TPOL)+totalProfit
            profitPer.value = (profit/Number(currentBalance.PAYMONEY))*100; 
          }
        }

        // else if(_type == 'F' && currentBalance_F && profitData_F)
        // {
                  
        //   totalBalance_F.value = totalProfit +  Number(currentBalance_F.BALANCE);  
        //   let profit = Number(profitData_F.TPOL)+totalProfit
        //   profitPer_F.value = (profit/Number(currentBalance_F.PAYMONEY))*100;    
          
        // }
        // else if(_type == 'C' && currentBalance_C && profitData_C)
        // {     
        //   totalBalance_C.value = totalPrice +  Number(currentBalance_C.BALANCE);
        //   let profit = Number(profitData_C.TPOL)+totalProfit
        //   profitPer_C.value = (profit/Number(currentBalance_C.PAYMONEY))*100;    
        
        // }
    }

    const getProfitlist = async(_type, _spaceId)=>{            
        var res = await apiCall_gt(`vspace/getprofitlistbyday?type=${_type}&spaceId=${_spaceId}`);
        if(!res)return
        if(!res.dataSum)return null;
        return res.dataSum;
    }


    const  getCurrentBalance = async (spaceId)=>{       
        var token = sessionStorage.getItem('token');  
      try{            
          const res = await axios.get(`vspace/getaccountbyspaceid?spaceId=${spaceId}`,{
              headers: {
                  'token': token
              }
          } );
          let json =  res.data;              
          if (json.returnCode == 1) { 
              if (json.resultMap.returnVal == 1) {     
                  // console.log("getCurrentBalance:", json.resultMap.data.BALANCE, json.resultMap.data.PAYMONEY)               
                    return json.resultMap.data;                     
              } else { 
                    return false
                              
              }
          }           
          else
          {              
              console.log("error", json.message);    
              return false           
          }  
      }catch(error){     
          console.log(error);  
          return false;           
      }  
    }

    onMounted(() => {
       setApplySpaceList();

        clearInterval(intervalId);
        intervalId = setInterval(()=>{
              if(currentAssetList.value)
              {
                setTotalProfit(currentAssetList.value)    
              }               
        },1000);  
    })

    onUnmounted(()=>{
       if(intervalId)clearInterval(intervalId);
       if(currentAssetList.value)leaveAssetItems(currentAssetList.value);
    })

    const onResultTab = async(type) => {
      if(resultType.value != type)
      {
        if(currentAssetList.value)leaveAssetItems(currentAssetList.value);
        totalBalance.value = 0;
        profitPer.value = 0;
        isApplyCurrentSpace.value = false;

        resultType.value = type;
        console.log('resultType', resultType.value)
        currentAssetList.value = [];
        if(type=='S')
        {
         
          currentAssetList.value = await getAssetList('S');
          if(applySpace_S.value)
          {
            currentBalance = await getCurrentBalance(applySpace_S.value.ID);
            profitData = await getProfitlist('S',applySpace_S.value.ID);
            isApplyCurrentSpace.value = true;
          }
        }
        else if(type=='F')
        {
          currentAssetList.value = await getAssetList('F');
          if(applySpace_F.value)
          {
            currentBalance = await getCurrentBalance(applySpace_F.value.ID);
            profitData = await getProfitlist('F',applySpace_F.value.ID);
            isApplyCurrentSpace.value = true;
          }
        }
        else if(type=='C')
        {
          currentAssetList.value = await getAssetList('C');
          if(applySpace_C.value)
          {
            currentBalance = await getCurrentBalance(applySpace_C.value.ID);   
            profitData = await getProfitlist('C',applySpace_C.value.ID);
            isApplyCurrentSpace.value = true;
          }
        }
        else if(type=='G')
        {
          currentAssetList.value = await getAssetList('G');
          if(applySpace_G.value)
          {
            currentBalance = await getCurrentBalance(applySpace_G.value.ID);
            profitData = await getProfitlist('G',applySpace_G.value.ID);
            isApplyCurrentSpace.value = true;
          }
        }
        requesAssetItems(currentAssetList.value)
      }     

    }


    const onItemClicked = (item) =>{
      console.log("onItemClicked:", item.CODE, resultType.value);
      //router
      store.commit('hts/CHANGE_TRADE_TYPE', resultType.value);
      router.push({
        name: 'TradeArea',
        params: {
          code:item.CODE,   
          id:'0'          
        }
      }) 


    }


    const getNdotpos_G = (_code) =>{
      var result = 0
      // console.log("getNdotpos ", _code )
      var items_G =  JSON.parse(sessionStorage.getItem(`items_G`))   
      
      if(items_G && items_G.length > 0)
      {
          var found = items_G.find(element => element.CODE ==  _code); 
          if(found && found.NDOTPOS )
          {
            result = parseInt(found.NDOTPOS);
          }
      }
     // console.log("getNdotpos ", _code , result)
      return result;
    }

    const getCssColor = (num) => {
      var result = ''
      if(num > 0)
      {
          result = "up" 
      }
      else if(num < 0)
      {
          result = "down"         
      }
      else
      {
          result = ""      
      } 
      return result;
    }

    const getLongShortColor=(_tradeType)=>{ 
      var result = '' 
      if(_tradeType == '3' || _tradeType == '5')
      {
            result = 'up'
      }
      else if(_tradeType == '4' || _tradeType == '6')
      {
           result = 'down'
      }       
      return result;
    }
    return {
      onResultTab,
      resultType,
      options: {       
        wheelSpeed: 1,
        wheelPropagation: true,
        minScrollbarLength: 20,
        suppressScrollX: true,
      },
      watcher: true, 
      currentAssetList,
      Constant,
      getTradeType,
      getCssColor,
      getLongShortColor,
      getNdotpos_G,
      profitPer,
      totalBalance,
      isApplyCurrentSpace,
      onItemClicked
    }
  }
}
</script>

<style>

</style>